import { useAPI } from '@/services';
import { UseQueryOptions } from 'react-query';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

export const useGetUserContractFund = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const fundCode = useGetFundCodeFromQuery();
  const response = useAPI(['paymentService', 'getUserContractFund'], {
    reactQueryOptions,
    input: {
      fundCode,
    },
  });

  const hasUserContractFund = !!response.data?.items.length;

  return {
    hasUserContractFund,
    ...response,
  };
};
